module.exports = __webpack_public_path__ + "img/meoo.c11d443c.png";